/**
 * Wishlist — localStorage-backed, vanilla JS.
 * Works with:
 *   - snippets/button-wishlist.liquid  -> [data-wishlist-toggle][data-product-handle]
 *   - sections/main-wishlist-page.liquid -> [data-wishlist-grid] / [data-wishlist-empty]
 *   - header wishlist icon -> .wishlist-count-bubble
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'renew-wishlist';
  var ACTIVE_CLASS = 'is-wishlisted';
  var TOAST_DURATION = 4000;

  var selectors = {
    toggle: '[data-wishlist-toggle]',
    countBubble: '.wishlist-count-bubble',
    grid: '[data-wishlist-grid]',
    empty: '[data-wishlist-empty]',
    toast: '#wishlist-toast',
  };

  var toastTimer = null;

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    syncButtons();
    syncCountBubbles(handles.length);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { wishlist: handles } }));
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var wishlist = getWishlist();
    var index = wishlist.indexOf(handle);
    var added;

    if (index === -1) {
      wishlist.push(handle);
      added = true;
    } else {
      wishlist.splice(index, 1);
      added = false;
    }

    saveWishlist(wishlist);
    return added;
  }

  function removeFromWishlist(handle) {
    var wishlist = getWishlist();
    var index = wishlist.indexOf(handle);
    if (index === -1) return;
    wishlist.splice(index, 1);
    saveWishlist(wishlist);
  }

  function syncButtons(scope) {
    var wishlist = getWishlist();
    var root = scope || document;
    root.querySelectorAll(selectors.toggle).forEach(function (button) {
      var handle = button.dataset.productHandle;
      var active = wishlist.indexOf(handle) !== -1;
      button.classList.toggle(ACTIVE_CLASS, active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncCountBubbles(count) {
    if (typeof count !== 'number') count = getWishlist().length;
    document.querySelectorAll(selectors.countBubble).forEach(function (bubble) {
      bubble.textContent = count > 0 ? String(count) : '';
      bubble.hidden = count === 0;
    });
  }

  function onToggleClick(event) {
    if (event.target.closest('.wishlist-toast__close')) {
      hideToast();
      return;
    }

    var button = event.target.closest(selectors.toggle);
    if (!button) return;

    var handle = button.dataset.productHandle;
    if (!handle) return;

    event.preventDefault();
    var added = toggleWishlist(handle);

    if (added) {
      showToast(button);
    } else {
      var grid = document.querySelector(selectors.grid);
      if (grid) {
        var item = grid.querySelector('[data-wishlist-item="' + handle + '"]');
        if (item) item.remove();
        toggleEmptyState();
      }
    }
  }

  function showToast(button) {
    var toast = document.querySelector(selectors.toast);
    if (!toast) return;

    var title = button.dataset.productTitle || '';
    var image = button.dataset.productImage || '';

    toast.querySelector('.wishlist-toast__title').textContent = title;
    var img = toast.querySelector('.wishlist-toast__image');
    img.src = image;
    img.alt = title;

    toast.classList.add('active');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('active');
    }, TOAST_DURATION);
  }

  function hideToast() {
    var toast = document.querySelector(selectors.toast);
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.remove('active');
  }

  function toggleEmptyState() {
    var grid = document.querySelector(selectors.grid);
    var empty = document.querySelector(selectors.empty);
    if (!grid || !empty) return;
    var hasItems = grid.children.length > 0;
    grid.hidden = !hasItems;
    empty.hidden = hasItems;
  }

  function fetchProductCard(handle) {
    return fetch('/products/' + handle + '?view=card')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-wishlist-item]');
        return card ? card.outerHTML : null;
      })
      .catch(function () {
        return null;
      });
  }

  function renderWishlistGrid() {
    var grid = document.querySelector(selectors.grid);
    if (!grid) return;

    var wishlist = getWishlist();

    if (!wishlist.length) {
      grid.innerHTML = '';
      toggleEmptyState();
      return;
    }

    grid.setAttribute('aria-busy', 'true');

    Promise.all(wishlist.map(fetchProductCard)).then(function (cards) {
      var validHandles = [];
      var html = '';

      cards.forEach(function (card, index) {
        if (card) {
          html += card;
          validHandles.push(wishlist[index]);
        }
      });

      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');

      // Self-heal: drop handles for products that no longer exist (deleted/unpublished).
      if (validHandles.length !== wishlist.length) {
        saveWishlist(validHandles);
      }

      toggleEmptyState();
      syncButtons(grid);
    });
  }

  function init() {
    syncButtons();
    syncCountBubbles();
    renderWishlistGrid();
  }

  document.addEventListener('click', onToggleClick);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  }

  window.Wishlist = {
    get: getWishlist,
    has: isWishlisted,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
  };
})();
